import { memoize } from 'lodash'

// Four needs to be loaded upfront for isAuthenticated to work properly
import Four from './Four'
import One from './One'
import Two from './Two'
import Three from './Three'
import Five from './Five'
import Six from './Six'

// import * as Lazy from './LazyRoutes'

// const componentsForSteps = [
//   undefined, // no step 0 to simplify indexing/display
//   Lazy.One, // start at step 1
//   Lazy.Two,
//   Lazy.Three,
//   Four,
//   Lazy.Five,
//   Lazy.Six
// ]

const componentsForSteps = [
  undefined,
  One,
  Two,
  Three,
  Four,
  Five,
  Six
]

export const componentForStep = step => {
  if (!isValidStep(step)) {
    throw new Error(`invalid step: ${step}`)
  }
  return componentsForSteps[step]
}

// TODO: MEMOIZE!
const _shouldDisplayStep = (n, state) => {
  if (!isValidStep(n)) {
    return false
  }

  const step = componentForStep(n)

  if (typeof step.shouldDisplayStep !== 'function') {
    return true
  }

  return step.shouldDisplayStep(state)
}

const shouldDisplayStep = (...args) => {
  const shouldDisplayStep = _shouldDisplayStep(...args)

  return shouldDisplayStep
}

const findProximateStepNumber = (direction, currentStepNumber, state) => {
  const operation = {
    '+': n => n + 1,
    '-': n => n - 1
  }[direction]

  if (!operation) {
    throw new Error('invalid direction:' + direction)
  }

  const neighboringStepNumber = operation(currentStepNumber)

  if (!isValidStep(neighboringStepNumber)) {
    return
  }

  if (shouldDisplayStep(neighboringStepNumber, state)) {
    return neighboringStepNumber
  }

  return findProximateStepNumber(direction, neighboringStepNumber, state)
}

/**
 * findProximateStepNumbers: returns array containing the next and previous step numbers based on current step
 * and state of flow
 *
 * @param {*} currentStepNumber
 * @param {*} state
 */
export const findProximateStepNumbers = (currentStepNumber, state) => [
  findProximateStepNumber('+', currentStepNumber, state),
  findProximateStepNumber('-', currentStepNumber, state)
]

export const isValidStep = memoize(
  step => step > 0 && step < componentsForSteps.length
)
